import React, { useState } from "react";

import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';


export const InwardDetail = ({ Muldata }) => {



  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);

  const formatIndianRupee1 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount ?? 0);

  const { InwDatetailData } = useSelector((state) => state.PartyProfileSlice);
  const { AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;




  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "InwardDate", label: "InwardDate", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "ChallanNo", label: "Challan No", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "PartyMarka", label: "Party Marka", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "lotno", label: "LotNo", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "acname", label: "Party Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "TotalTaka", label: "Total Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "TotalMeter", label: "Total Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  const columnFields = ["ChallaNo", "lotno", "TotalTaka", "TotalMeter"];

  const formattedRows = InwDatetailData?.InwDate?.map((row, index, arr) => {
    const totalLength = arr.length.toString().length;
    const formattedRow = {
      id: index,
      // srNumber: (index + 1).toString().padStart(totalLength, "0"),
      ...row,
      InwardDate: new Date(row.InwardDate).toLocaleDateString("en-GB"),
    };

    // Apply formatIndianRupee ONLY to TotalMeter
    formattedRow["TotalMeter"] = formatIndianRupee(row["TotalMeter"]);

    // Apply formatIndianRupee1 to other fields (excluding TotalMeter)
    columnFields.forEach((field) => {
      if (field !== "TotalMeter") {
        formattedRow[field] = formatIndianRupee1(row[field]);
      }
    });

    return formattedRow;
  });

  if (InwDatetailData === null) {

    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div>
        <Row>
          <Col>

            <>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: "14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                    MERGING
                  </h2>
                </div>
                {InwDatetailData?.InwDate &&
                  InwDatetailData?.InwDate?.length > 0 ? (
                  <GreyTable columns={columns} data={formattedRows} iscolourDark={iscolourDark}
                    iscolour={iscolour} />
                ) : (
                  <p
                    style={{
                      color: "#ff0000",
                      fontWeight: "bold",
                      padding: "10px",
                    }}
                  >
                    Data Not Found
                  </p>
                )}
              </div>
            </>

            {Muldata?.map((el) => {
              const formattedRows1 = el?.InwDate?.map((row, index, arr) => {
                const totalLength = arr.length.toString().length;
                const formattedRow = {
                  id: index,
                  srNumber: (index + 1).toString().padStart(totalLength, "0"),
                  ...row,
                  InwardDate: new Date(row.InwardDate).toLocaleDateString("en-GB"),
                };

                columnFields.forEach((field) => {
                  formattedRow[field] = formatIndianRupee(row[field]);
                });

                return formattedRow;
              });
              return (
                <>
                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour8,
                        padding: "14px",
                      }}
                    >
                      <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" ,fontWeight:"700"}}>
                        {AccountToPGroupListData?.Data?.find(
                          (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                        )?.ProductionGroupMstName || `Group ${el.group}`}
                      </h2>
                    </div>

                    {el?.InwDate && el?.InwDate?.length > 0 ? (
                      <GreyTable columns={columns} data={formattedRows1} iscolourDark={iscolourDark}
                        iscolour={iscolour} />
                    ) : (
                      <p
                        style={{
                          color: "#ff0000",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Data Not Found
                      </p>
                    )}
                  </div>
                </>

              );
            })}


          </Col >
        </Row>
      </div>
    </>
  )
}


